import React from 'react';
import { ArrowRightIcon } from 'lucide-react';

// Real checkout — used ONLY by the CTA inside the offer/pricing card.
// Every other CTA scrolls to the offer card instead.
export const CHECKOUT_URL = 'https://innebandy-ready.impultienda.ar/checkout';

// Anchor of the price block inside the offer card.
export const OFFER_ANCHOR = '#lanseringspris';

// Height of the sticky offer bar plus a little breathing room.
const STICKY_OFFSET = 60;
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'SKAFFA INNEBANDY READY-PAKETET',
  href = OFFER_ANCHOR,
  className = ''
}: CtaButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (!isAnchor) {
      // Escape the preview iframe so the checkout always opens.
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    const target = document.querySelector(href);
    if (!target) return;

    // Center the offer block in the space below the sticky bar.
    const rect = target.getBoundingClientRect();
    const visibleHeight = window.innerHeight - STICKY_OFFSET;
    const centerGap = Math.max((visibleHeight - rect.height) / 2, 12);
    const top = Math.max(rect.top + window.scrollY - STICKY_OFFSET - centerGap, 0);
    window.scrollTo({
      top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  };
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`group flex w-full items-center justify-center gap-2.5 rounded-full bg-gold px-7 py-5 text-center text-base font-extrabold uppercase tracking-wide text-navy shadow-[0_10px_28px_-12px_rgba(22,50,79,0.55)] transition-colors duration-150 ease-out hover:bg-gold-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/45 sm:text-lg ${className}`} data-id="element-62" data-mp="3svivjhf3zxkf">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-63" data-mp="3hz5kg0v88atl" />
    </a>;
}